import React from 'react';
import LocationTemplate from './LocationTemplate';

const WendellPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wendell"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27591"]}
      latitude={35.781}
      longitude={-78.3697}
      population={10243}
      historicalFact="Named after poet Oliver Wendell Holmes; originally spelled 'Wendall' but corrected after incorporation."
      nearbyTowns={[
        "Zebulon, NC",
        "Knightdale, NC",
        "Raleigh, NC",
        "Wake Forest, NC",
        "Clayton, NC",
        "Rolesville, NC",
        "Louisburg, NC",
        "Middlesex, NC"
      ]}
    />
  );
};

export default WendellPage;